// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"a40f86d2","276":"485c113d","488":"0f1e4911","544":"fd733fc8","736":"c0567e2d","888":"eb715df2"}[chunkId] + ".chunk.js";
};